export default "__VITE_ASSET__d229b92e__"